import ometiff from './ometiff'
import validate from './validate'
import checkSamples from './checkSamples'
import checkJSONAndField from './checkJSONAndField'

export default {
  ometiff,
  validate,
  checkSamples,
  checkJSONAndField,
}
